import React, { useState } from "react";
import styled from "styled-components";

import useWindowDimensions from "../utils/hooks/useWindowDimensions";
import { modesData } from "../utils/globalConst";
import arrowDown from "../svg/down-arrow-white.svg";

const Container = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  overflow: hidden;
  width: 100%;
  height: auto;
  background: transparent;
  overflow: hidden;
  z-index: 100;

  ul,
  .mode-display {
    border: 1px solid #fff;
    padding: 7px 12px;
    text-align: left;
    opacity: 0.9;
    border-radius: 30px;
    cursor: pointer;

    p {
      margin: 0;
    }

    &:hover {
      opacity: 0.95;
    }
  }

  .mode-display {
    img {
      width: 14px;
      height: auto;
      position: absolute;
      right: 15px;
      top: 10px;

      transition: transform 0.25s ease;
    }
  }

  ul {
    border-radius: 15px;
    opacity: 0.9;
    margin: 0;
    margin-top: 1px;
    background-color: #424242;

    li {
      margin: 15px auto;
      opacity: 0.85;
      list-style-type: none;

      &:hover {
        opacity: 0.95;
      }
    }
  }

  ${({ windowWidth, showDropdown }) => `
    max-width: ${windowWidth <= 400 ? windowWidth - 85 : 300}px;
    
    .mode-display {
      img {
        transform: ${showDropdown ? `rotate(180deg)` : `rotate(0deg)`};
      }
    }
  `}
`;

const ModeSelector = ({ mode, setMode }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const { width: windowWidth } = useWindowDimensions();

  const handleMode = (modeTitle, enabled) => {
    if (enabled) {
      setMode(modeTitle);
      setShowDropdown(false);
    }
  };
  const handleSelect = () => setShowDropdown(!showDropdown);

  return (
    <Container {...{ showDropdown, windowWidth }}>
      <div className="mode-display" onClick={handleSelect}>
        <p>{mode}</p>
        <img src={arrowDown} />
      </div>
      {showDropdown && (
        <ul className="modes-list">
          {modesData.map((mode) => (
            <li
              value={mode.title}
              onClick={() => handleMode(mode.title, mode.enabled)}
              style={{ opacity: mode.enabled ? 0.7 : 0.35 }}
            >
              {mode.title}
            </li>
          ))}
        </ul>
      )}
    </Container>
  );
};

export default ModeSelector;
